// frontend/src/components/TransactionsTable.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TransactionsTable = ({documentId}) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const token = localStorage.getItem("token");
    useEffect(() => {
        if (documentId) {
            fetchTransactions();
        }
    }, [documentId]);

    const fetchTransactions = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
            `https://bank-converter-app-3.onrender.com/documents/${documentId}/transactions`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            }
        );
            setTransactions(response.data.transactions);
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
        } finally {
            setLoading(false);
        }
    };





    const formatCurrency = (amount) => {
        if (!amount || amount === '' || amount === 0) return '';

        try {
            const numAmount = typeof amount === 'string' ?
                parseFloat(amount.replace(/[$,]/g, '')) :
                parseFloat(amount);

            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(numAmount);
        } catch {
            return amount;
        }
    };

    const formatDate = (dateStr) => {
        try {
            if (!dateStr) return '';

            // Handle MM/DD/YYYY format
            if (dateStr.includes('/')) {
                const [month, day, year] = dateStr.split('/');
                const date = new Date(year, month - 1, day);
                return date.toLocaleDateString('en-US');
            }

            // Handle other date formats
          const date = new Date(dateStr);
          if (isNaN(date)) return dateStr;  // fallback if string like "14 Feb 13"
          return date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
     } catch {
            return dateStr;
        }
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px'
            }}>
                Loading transactions...
            </div>
        );
    }

    if ( transactions.length === 0) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '40px',
                color: '#666'
            }}>
            <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f8f9fa' }}>
                <h3>🔍 Debug API Response</h3>
            </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '10px' }}>

            {/* Transactions Table */}
            <div style={{ overflowX: 'auto' }}>
                <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'left',
                                fontWeight: 'bold'
                            }}>
                                Date
                            </th>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'left',
                                fontWeight: 'bold'
                            }}>
                                Description
                            </th>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'left',
                                fontWeight: 'bold'
                            }}>
                                Category
                            </th>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'right',
                                fontWeight: 'bold'
                            }}>
                                Debit
                            </th>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'right',
                                fontWeight: 'bold'
                            }}>
                                Credit
                            </th>
                            <th style={{
                                border: '1px solid #ddd',
                                padding: '12px 8px',
                                textAlign: 'right',
                                fontWeight: 'bold'
                            }}>
                                Balance
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((transaction, index) => (
                            <tr key={transaction.id || index} style={{
                                backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                            }}>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {formatDate(transaction.date || transaction.transaction_date)}
                                </td>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    maxWidth: '300px',
                                    wordWrap: 'break-word'
                                }}>
                                    {transaction.description}
                                </td>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    textAlign: 'center'
                                }}>
                                    {transaction.category}
                                </td>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    textAlign: 'right',
                                    color: '#dc3545'
                                }}>
                                    {formatCurrency(transaction.debit_amount)}
                                </td>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    textAlign: 'right',
                                    color: '#28a745'
                                }}>
                                    {formatCurrency(transaction.credit_amount)}
                                </td>
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    textAlign: 'right',
                                    fontWeight: 'bold'
                                }}>
                                    {formatCurrency(transaction.balance)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TransactionsTable;
